import React, { Component } from 'react'
import Autosuggest from 'react-autosuggest'
import axios from 'axios'
import {transliterate as tr} from 'transliteration'

class Autocomplete extends Component {
  state = {
    suggestions: [],
    list: false
  }

  componentDidMount() {
    axios.get((process.env.NODE_ENV === 'development' ? process.env.REACT_APP_NOT_SECRET_CODE : '') + this.props.url).then((res) => {
      const list = res.data.data.map(m => m.title)
      this.setState({list})
    })
  }

  render() {
    const {name, index, placeholder, title, validate, change, value} = this.props
    
    return (
      <React.Fragment>
        <label htmlFor={`${name}-field-${index}`} className="block text-sm font-semibold text-red mb-5">{title}{ validate && validate.required ? ' *' : '' }</label>
        <Autosuggest
          suggestions={this.state.suggestions}
          inputProps={{
            className: "text-input w-full max-w-sm2 border rounded-md border-grey-darker h-18 px-6 md:text-lg text-sm font-medium text-black",
            value,
            placeholder,
            name,
            id: `${name}-field-${index}`,
            onChange: (e, { newValue }) => change(index, newValue, {list: this.state.list}),
            autoComplete: "on"
          }}
          getSuggestionValue={suggestion => suggestion}
          onSuggestionsFetchRequested={({ value }) => {
            this.setState({
              suggestions: this.getSuggestions(value)
            })
          }}
          onSuggestionsClearRequested={() => {
            this.setState({
              suggestions: []
            })
          }}
          renderSuggestion={(item, { query, isHighlighted }) => {
            // find search query in item and highlight it
            const re = new RegExp(`(${query})`, 'gi')
            const highlighted = item.replace(re, str => `<strong>${str}</strong>`)
            
            return (
              <div dangerouslySetInnerHTML={{__html: highlighted}} className={`h-12 px-6 text-lg font-medium text-black text-black cursor-pointer hover:bg-grey-lightest ${isHighlighted ? 'bg-grey-lightest' : 'bg-white'}`} />
            )
          }}
        />
      </React.Fragment>
    )
  }

  getSuggestions = (value) => {
    let inputValue = value.trim().toLowerCase()
    const inputLength = inputValue.length
    const results = inputLength === 0 ? [] : this.state.list.filter(m => {
      m = m.toLowerCase()
      const mtr = tr(m)
      return mtr.slice(0, inputLength) === inputValue || m.slice(0, inputLength) === inputValue
    })
  
    return results
  }
}

export default Autocomplete